/* eslint-disable no-undef */
import Vue from 'vue'
import Vuex from 'vuex'
import Client from '../utils/client'
import myProfileModule from './MyProfileModule/moduleMyProfile'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    referrer: '',
    aId: '',
    pageId: '',
    langId: 1,
    biskoId: '',
    appName: '',
    cId: '',
    tId: '',
    oI: '',
    clientToken: '',
    offer: undefined,
    papD: undefined,
    papId: '',
    stripe: undefined,
    client: undefined,
    returnUrl: null,
    returnSuccessUrl: null,
    returnErrorUrl: null,
    selectedPap: null,
    licenseForm: null,
    giftId: null,
    profileName: null,
    redeemIsClosable: false,
    cpt: null,
    cft: null,
    user: {
      name: null,
      profileImage: null,
    },
    giftLanguage: {
      package_checkout_gift_redeem_details: 'Redeem your gift subscription',
      package_checkout_gift_redeem_description: 'Enter the voucher code below to reedem your subscription:',
      package_checkout_gift_redeem_label_voucher_code: 'Voucher Code',
      package_checkout_gift_redeem_placeholder_voucher_code: 'Enter the voucher code...',
      package_checkout_gift_redeem_button_redeem: 'Redeem gift',
      package_checkout_gift_redeem_under_button_text: 'If you are having any issues or questions, please contact us.',
      package_checkout_gift_redeem_login_details: 'Please log in to continue redeeming your gift',
      package_checkout_gift_redeem_login_button: 'login',
      package_checkout_gift_redeem_invalid_code: 'Invalid code!',
      package_checkout_gift_redeem_gift_redeemed: 'Gift Redeemed!',
    },
    showOffer: true,
    showLoader: false,
    loadingText: 'Logging in...',
    scrId: null,
    isLandingCheckoutModal: false,
    subId: null,
    experimentId: null,
    loginlessCheckout: false,
    loginlessEmail: '',
    loginUrl: null,
    loginCallbackUrl: null,
    firstName: '',
    lastName: '',
  },
  mutations: {
    setAId(state, value) {
      state.aId = value
    },
    setPapDetails(state, value) {
      state.papD = value
    },
    setPageId(state, value) {
      state.pageId = value
    },
    setLangId(state, value) {
      state.langId = value
    },
    setCId(state, value) {
      state.cId = value
    },
    setTId(state, value) {
      state.tId = value
    },
    setClientToken(state, value) {
      state.clientToken = value
      state.client = new Client(value)
    },
    setOffer(state, value) {
      state.offer = value
      state.oI = value.oi
    },
    setPapId(state, value) {
      state.papId = value
    },
    setStripe(state, value) {
      // console.error(loadStripe)
      // state.stripe = loadStripe(value)
      // console.error('stripe', state.stripe)
      state.stripe = value
    },
    setTi(state, value) {
      state.tId = value
    },
    setOi(state, value) {
      state.oI = value
    },
    setReturnUrl(state, value) {
      state.returnUrl = value
    },
    setReturnErrorUrl(state, value) {
      state.returnErrorUrl = value
    },
    setReturnSuccessUrl(state, value) {
      state.returnSuccessUrl = value
    },
    setBiskoId(state, value) {
      state.biskoId = value
    },
    setAppName(state, value) {
      state.appName = value
    },
    setSelectedPap(state, value) {
      state.selectedPap = value
    },
    setLicenseForm(state, value) {
      state.licenseForm = value
    },
    setGiftId(state, data) {
      state.giftId = data
    },
    setProfileName(state, data) {
      state.profileName = data
    },
    setRedeemIsClosable(state, data) {
      state.redeemIsClosable = data
    },
    setGiftLanguage(state, data) {
      state.giftLanguage = data
    },
    setUser(state, data) {
      // state.user = data
      Vue.set(state, 'user', data)
    },
    setCpt(state, data) {
      state.cpt = data
    },
    setCft(state, data) {
      state.cft = data
    },
    setShowOffer(state, data) {
      state.showOffer = data
    },
    setShowLoader(state, data) {
      state.showLoader = data
    },
    setLoadingText(state, data) {
      state.loadingText = data
    },
    setScrId(state, data) {
      state.scrId = data
    },
    setIsLandingCheckoutModal(state, data) {
      state.isLandingCheckoutModal = data
    },
    setSubId(state, data) {
      state.subId = data
    },
    setExperimentId(state, data) {
      state.experimentId = data
    },
    setLoginlessCheckout(state, data) {
      state.loginlessCheckout = data
    },
    setLoginlessEmail(state, data) {
      state.loginlessEmail = data
    },
    setLoginUrl(state, data) {
      state.loginUrl = data
    },
    setLoginCallbackUrl(state, data) {
      state.loginCallbackUrl = data
    },
    setFirstName(state, data) {
      state.firstName = data
    },
    setLastName(state, data) {
      state.lastName = data
    },
  },
  getters: {
    aId: (state) => state.aId,
    pageId: (state) => state.pageId,
    langId: (state) => state.langId,
    papD: (state) => state.papD,
    cId: (state) => state.cId,
    tId: (state) => state.tId,
    oI: (state) => state.oI,
    clientToken: (state) => state.clientToken,
    client: (state) => state.client,
    offer: (state) => state.offer,
    papId: (state) => state.papId,
    paps: (state) => (state.offer ? state.offer.paps : []),
    stripe: (state) => state.stripe,
    isLoggedIn: (state) => !(
      state.clientToken === ''
        || state.clientToken === undefined
        || state.clientToken === null
        || state.clientToken === 'null'
    ),
    returnUrl: (state) => state.returnUrl,
    returnSuccessUrl: (state) => state.returnSuccessUrl,
    returnErrorUrl: (state) => state.returnErrorUrl,
    biskoId: (state) => state.biskoId,
    appName: (state) => state.appName,
    selectedPap: (state) => state.selectedPap,
    licenseForm: (state) => state.licenseForm,
    giftId: (state) => state.giftId,
    profileName: (state) => state.profileName,
    redeemIsClosable: (state) => state.redeemIsClosable,
    giftLanguage: (state) => state.giftLanguage,
    user: (state) => state.user,
    cpt: (state) => state.cpt,
    cft: (state) => state.cft,
    showOffer: (state) => state.showOffer,
    showLoader: (state) => state.showLoader,
    loadingText: (state) => state.loadingText,
    scrId: (state) => state.scrId,
    isLandingCheckoutModal: (state) => state.isLandingCheckoutModal,
    subId: (state) => state.subId,
    experimentId: (state) => state.experimentId,
    loginlessCheckout: (state) => state.loginlessCheckout,
    loginlessEmail: (state) => state.loginlessEmail,
    loginUrl: (state) => state.loginUrl,
    loginCallbackUrl: (state) => state.loginCallbackUrl,
    firstName: (state) => state.firstName,
    lastName: (state) => state.lastName,
  },
  actions: {},
  modules: {
    myProfileModule,
  },
})
